const parts = {
  namespaced: true,
  state: {
    current: "",
    parts: {
      head: [
        {
          name: "マグロボの頭",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 25,
          ap: 30,
          dp: 30,
          mb: 30
        },
        {
          name: "5Gヘッド",
          description: "どんな相手も高速データ分析だ！",
          hitRate: 25,
          ap: 50,
          dp: 50,
          mb: 80
        },
        {
          name: "スカウター",
          description: "相手の攻撃力を測定できる//マグロボスカウターだ！//",
          hitRate: 25,
          ap: 20,
          dp: 20,
          mb: 40
        },
        {
          name: "VRゴーグル",
          description: "邪魔だ。前がよく見えない･･･",
          hitRate: 25,
          ap: 10,
          dp: 10,
          mb: 10
        }
      ],
      body: [
        {
          name: "マグロボのボディ",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 30,
          ap: 30,
          dp: 40,
          mb: 30
        },
        {
          name: "タヌキボディ",
          description: "これは･･･東広島の有名マスコット！？",
          hitRate: 30,
          ap: 10,
          dp: 50,
          mb: 20
        },
        {
          name: "黄金に輝くマグロボディ",
          description: "！！！幻の金マグロ！！//超レアアイテムだ！//",
          hitRate: 10,
          ap: 100,
          dp: 200,
          mb: 150
        },
        {
          name: "マスクマグロ",
          description: "マグロだって予防が大事！",
          hitRate: 30,
          ap: 10,
          dp: 100,
          mb: 30
        }
      ],
      rightArm: [
        {
          name: "マグロボの右腕",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 30,
          ap: 30,
          dp: 30,
          mb: 30
        },
        {
          name: "マッチョな右腕",
          description: "力だけは誰にも負けない！",
          hitRate: 30,
          ap: 80,
          dp: 30,
          mb: 50
        },
        {
          name: "溶接マスクを持った右腕",
          description: "溶接時のマストアイテム！",
          hitRate: 30,
          ap: 10,
          dp: 100,
          mb: 50
        },
        {
          name: "マグロ",
          description:
            "レアアイテム出現！このマグロを//どう使うのかはキミ次第だ！//",
          hitRate: 10,
          ap: 100,
          dp: 50,
          mb: 80
        }
      ],
      leftArm: [
        {
          name: "マグロボの左腕",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 25,
          ap: 30,
          dp: 30,
          mb: 30
        },
        {
          name: "フラスコ",
          description: "実験に使えそうだ。",
          hitRate: 25,
          ap: 10,
          dp: 10,
          mb: 10
        },
        {
          name: "マグロボの盾",
          description: "防御力が格段にアップした！！",
          hitRate: 25,
          ap: 30,
          dp: 150,
          mb: 50
        },
        {
          name: "トンカチ",
          description: "最強の武器を手に入れた！！",
          hitRate: 25,
          ap: 150,
          dp: 50,
          mb: 50
        }
      ],
      leg: [
        {
          name: "マグロボの足",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 25,
          ap: 60,
          dp: 30,
          mb: 30
        },
        {
          name: "内股の足",
          description: "戦えるのか不安が残る･･･",
          hitRate: 25,
          ap: 10,
          dp: 10,
          mb: 10
        },
        {
          name: "ロボットの足",
          description: "内部構造が敵にバレバレだ･･･",
          hitRate: 25,
          ap: 50,
          dp: 10,
          mb: 30
        },
        {
          name: "タイヤの足",
          description: "スピードだけは誰にも負けない！",
          hitRate: 25,
          ap: 80,
          dp: 80,
          mb: 80
        }
      ],
      bg: [
        {
          name: "マグロボの背景",
          description: "これはマグロボの//オリジナルパーツのようだ。//",
          hitRate: 40,
          ap: 0,
          dp: 0,
          mb: 0
        },
        {
          name: "イケてる背景",
          description: "どんなマグロボも//イケてるマグロボに早変わり。//",
          hitRate: 20,
          ap: 0,
          dp: 0,
          mb: 0
        },
        {
          name: "夏の海の背景",
          description: "青空と海の似合う//ロボットといえばマグロボ。//",
          hitRate: 20,
          ap: 0,
          dp: 0,
          mb: 0
        },
        {
          name: "近畿大学の背景",
          description: "今日から近大工学部の生徒だ！！",
          hitRate: 20,
          ap: 0,
          dp: 0,
          mb: 0
        }
      ],
      emptyBox1: [
        {
          name: "ハズレ",
          description: "残念！ハズレ！",
          hitRate: 100,
          ap: 0,
          dp: 0,
          mb: 0
        }
      ],
      emptyBox2: [
        {
          name: "ハズレ",
          description: "残念！ハズレ！",
          hitRate: 100,
          ap: 0,
          dp: 0,
          mb: 0
        }
      ]
    }
  },
  mutations: {
    current(state, id) {
      state.current = id;
    }
  },
  actions: {
    get({ dispatch }) {
      dispatch("draw");
    },
    draw({ dispatch, state }) {
      const partName = state.current;
      const drawBox = state.drawBoxes[partName];
      const item_id = drawBox[Math.floor(Math.random() * drawBox.length)];
      dispatch("magrobo/setItem", [partName, item_id], { root: true });
    }
  }
};

const { state } = parts;
const drawBoxes = {};
Object.keys(parts.state.parts).forEach(key => {
  const parts = state.parts[key];
  const drawBox = [];
  parts.forEach((part, index) => {
    for (let i = 0; i < part.hitRate; i++) {
      drawBox.push(index + 1);
    }
    for (let i = 0; i < drawBox.length; i++) {
      let random = Math.floor(Math.random() * (i + 1));
      [drawBox[i], drawBox[random]] = [drawBox[random], drawBox[i]];
    }
    drawBoxes[key] = drawBox;
  });
});
parts.state.drawBoxes = drawBoxes;

export default parts;
